/* eslint-disable max-len */
import { MappingType } from 'nextcloud-api';
import { Circle } from '../../../services/microsoft/msGraphApi';
import { DefaultFolderActionType } from '../../actions/defaultFolder/actionTypes';
import { produce } from 'immer';

export enum DefaultFolderModalStep {
    SetFolder = 'set_folder',
    CircleSelection = 'circle_selection',
    Confirmation = 'confirmation',
}

const initialState = {
    id: null as number | null,
    path: null as string | null,
    scope: null as MappingType | null,
    isDefaultFolderLoaded: false as boolean,
    sharedCircle: null as string | null,
    defaultFolderFormData: {
        defaultFolderModalStep: null as DefaultFolderModalStep | null,
        id: null as number | null,
        path: null as string | null,
        scope: null as MappingType | null,
        circle: null as Circle | null,
    },
};

export function defaultFolderReducer(state = initialState, action) {
    switch (action.type) {
        case DefaultFolderActionType.SetDefaultFolder:
            return produce(state, (draft) => {
                draft.id = action.payload.defaultFolder.id;
                draft.path = action.payload.defaultFolder.path;
                draft.scope = action.payload.defaultFolder.scope;
                draft.sharedCircle = action.payload.defaultFolder.circle;
                draft.isDefaultFolderLoaded = true;
            });
        case DefaultFolderActionType.SetDefaultFolderModalStep:
            return produce(state, (draft) => {
                draft.defaultFolderFormData.defaultFolderModalStep =
                    action.payload.step;
            });
        case DefaultFolderActionType.SetFormDefaultFolderId:
            return produce(state, (draft) => {
                draft.defaultFolderFormData.id = action.payload.id;
            });
        case DefaultFolderActionType.SetFormDefaultFolderPath:
            return produce(state, (draft) => {
                draft.defaultFolderFormData.path = action.payload.path;
            });
        case DefaultFolderActionType.SetFormDefaultFolderScope:
            return produce(state, (draft) => {
                draft.defaultFolderFormData.scope = action.payload.scope;
            });
        case DefaultFolderActionType.SetFormDefaultFolderCircles:
            return produce(state, (draft) => {
                draft.defaultFolderFormData.circle = action.payload.circle;
            });
        default:
            return state;
    }
}
